import top from "@/pages/global/components/top-bar/top-bar.vue";
import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

import { mapActions, mapState } from "vuex";
import Helper from "../../../helpers/helpers";

export default {
    name: 'Profile',
    beforeMount() {
        // this.$store.dispatch('announcements/fetchAnnouncements');
        this.$store.dispatch('profile/fetchUserProfile', {
            'visitedUserId': this.$route.params.userId,
            'visiterUserId': this.currentUser.uid,
        });
    },
    components: {
        top,
        navigation,
        bottom,
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            currentUser: state => state.currentUser,
        }),
        ...mapState('profile', {
            user: state => state.user,
            userLoaded: state => state.userLoaded,
            visiterIsBlocked: state => state.visiterIsBlocked,
        }),
        // ...mapState('announcements', {
        //     announcementsLoaded: state => state.announcementsLoaded,
        //     announcements: state => state.announcements,
        // }),
        // ...mapActions('announcements', {
        //     fetchAnnouncements: 'fetchAnnouncements'
        // })
    },
    methods: {
        copyProfileUrlToClipboard() {
            return Helper.copyUserProfileUrl(this.user.profile_link);
        },
        copyNetworkToClipboard(networkName, networkValue, networkField) {
            if(this.$route.params.userId !== this.currentUser.uid) {
                this.$store.dispatch('profile/writeNetworkClick', {
                    'network': networkField,
                });
            }
            return Helper.copyNetworkToClipboard(networkName, networkValue);
        },
        fetchUserEmail(userId) {
            this.$store.dispatch('profile/fetchUserEmail', {
                'userId': userId,
            });
        },
        writeNetworkClick(networkField) {
            if(this.$route.params.userId !== this.currentUser.uid) {
                this.$store.dispatch('profile/writeNetworkClick', {
                    'networkField': networkField,
                });
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/profile/master/profile.js